export default __webpack_public_path__ + "static/media/flashingdefense.7a009308.png";